import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AssociateSidebarService {
  constructor(private _http: HttpClient) {}

  /**
   * Trae la información del usuario
   */
  getUserInfo() {
    return this._http.get(environment.Api_get_user);
  }
  /**
   * Trae toda la información del usuario
   */
  getCompleteUserInfo() {
    return this._http.get(environment.Api_info_user);
  }
  /**
   * Actualizar la información del usuario
   */
  updateUserInfo(form) {
    return this._http.post(environment.Api_info_user, form);
  }
  /**
   * Cierra la sesión del usuario
   */
  sessionLogOut() {
    return this._http.get(environment.Api_logout);
  }
  /**
   * Actualiza la contraseña del usuario
   */
  updatePassword(body) {
    return this._http.post(environment.Api_update_password, body);
  }
  /**
   * Trae el token del asociado
   */
  getAssociateAPIToken() {
    return this._http.get(environment.associate.GET_TOKEN);
  }
}
